export default __webpack_public_path__ + "static/media/fxWalk.ff0a036a.mp3";